import MultipleView from 'components/Reward/RrcPromo/MultipleView/MultipleView';

export default MultipleView;
